import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import {
  SortableContainer,
  SortableElement,
  arrayMove,
} from 'react-sortable-hoc';
import { Icon } from 'merchant-portal-components';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

const FieldWrappedDiv = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 70px 1fr;
  background-color: white;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.14);
  padding: 12px 10px 12px 10px;
`;

const OptionCardDiv = styled.div`
  display: grid;
  grid-template-columns: 400px 1fr;
  align-items: center;
`;

const HeaderDiv = styled.div`
  display: grid;
  background-color: white;
  grid-template-columns: 70px auto 60px;
  padding: 0 10px 25px 10px;
  font-weight: bold;
`;

const StyledSortableContainer = styled.div`
  height: 100%;
  overflow-y: scroll; // need to be in container for auto scroll when sorting
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  border-radius: 12px;
  padding: 24px;
`;

const styles = {
  switchBase: {
    transition: 'none',
  },
  switchBaseDefault: {
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
};

const SortableItem = SortableElement(
  ({ option, optionIndex, index, arrayHelpers, isSorting, classes }) => {
    return (
      <FieldWrappedDiv>
        <Icon
          className='far fa-equals'
          style={{ cursor: 'move', textAlign: 'center' }}
        />
        <OptionCardDiv
          name={`options[${optionIndex}]`}
          style={{ cursor: 'pointer' }}
        >
          <div name={`options[${optionIndex}].option_name`}>{option.option_name}</div>
        </OptionCardDiv>
      </FieldWrappedDiv>
    );
  }
);

const SortableList = SortableContainer(
  ({ options, arrayHelpers, isSorting, classes }) => {
    return (
      <StyledSortableContainer>
        <HeaderDiv>
          <div />
          <div>Name</div>
        </HeaderDiv>
        {options.map((option, index) => (
          <SortableItem
            key={`option-${index}`}
            index={index}
            isSorting={isSorting}
            optionIndex={index}
            classes={classes}
            option={option}
            arrayHelpers={arrayHelpers}
          />
        ))}
      </StyledSortableContainer>
    );
  }
);

const RenderOptionsList = ({ sortOptions, arrayHelpers, classes }) => {
  const [isSorting, setIsSorting] = useState(false);
  const options = arrayHelpers.form.values.options;
  const setFieldValue = arrayHelpers.form.setFieldValue;
  return (
    <Fragment>
      <SortableList
        helperClass='sortableHelper'
        classes={classes}
        options={options}
        sortOptions={sortOptions}
        arrayHelpers={arrayHelpers}
        isSorting={isSorting}
        onSortStart={() => setIsSorting(true)}
        onSortEnd={({ oldIndex, newIndex }) => {
          const newList = arrayMove(options, oldIndex, newIndex);
          setFieldValue(`options`, newList);
          setTimeout(() => setIsSorting(false), 250);
        }}
        distance={1}
      />
    </Fragment>
  );
};

export default withStyles(styles)(RenderOptionsList);
